<template>
  <div>
    <SubHeader />

    <div class="container" v-if="!loaded">
      <div
        style="
          background-color: #f7f7f7;
          padding: 20px;
          margin-top: 20px;
          margin-bottom: 20px;
          text-align: center;
        "
      >
        <span style="color: #666; font-size: 18px"
          ><i class="bi bi-gear"></i><br />Loading maps and data...</span
        >
      </div>
    </div>

    <div
      class="container"
      v-if="loaded && projects.length > 0"
      style="background-color: #fff; padding-top: 15px"
    >
      <h2>Your Projects ({{ projects.length }})</h2>
      <p>Projects are a collection of factsheets for a particular purpose.</p>
      <div class="row" style="margin: 0px -5px">
        <div class="col-4" style="padding: 0px 5px" v-for="project in projects">
          <router-link
            class="item-project"
            :to="{
              name: 'project',
              params: {
                project_slug: project.slug ? project.slug : project.id,
              },
            }"
          >
            <strong
              ><i class="bi bi-archive-fill"></i> {{ project.name }}</strong
            >
            <p>{{ project.description }}</p>
            <div style="position: absolute; bottom: 22px">
              <span
                class="badge badge-secondary"
                style="
                  font-size: 0.7em;
                  background-color: #fff;
                  color: #444;
                  border: 1px solid #ccc;
                "
                ><i style="color: #888" class="bi bi-stack"></i>
                {{ project.factsheets_count }} Factsheets</span
              >&nbsp;
              <span
                class="badge badge-success"
                style="font-size: 0.7em"
                v-if="project.is_public"
                >Open Access</span
              >&nbsp;
            </div>
          </router-link>
        </div>
      </div>
      <hr />
    </div>
    <div
      class="container"
      v-if="loaded"
      style="background-color: #fff; padding-top: 15px"
    >
      <h2>Your Factsheets ({{ factsheets.length }})</h2>

      <FactsheetCollection :factsheets="factsheets" :showFilters="true" />

      <!--
    <template v-if="countLDR > 0">
        <div class="row">
          <div class="col">
          <h2>Your Landscape Diagnostic Reports ({{countLDR}})</h2>
          <p v-if="countLDR > 0">
          The overview below shows the Landscape Diagnostic Reports that your account has access to. Please contact your 
          administrator if you would like to define new areas of interest or if you have any other questions.
          </p>
          <p v-else>
          Oops! It seems like your account does not have any Landscape Diagnostic Reports associated with it yet. 
          </p>
          </div>
        </div>
        <div class="row" style="margin:0px -5px;">
            <Item v-for="item in factsheetsLdr" :item="item" :key="item.identifier"></Item>
        </div>
    </template>


    <template v-if="!profile.is_ldr">
        <div class="row">
          <div class="col">
          <h2>Your <span v-if="countLDR > 0">Other</span> Factsheets ({{countBasic}})</h2>
          <p v-if="countLDR > 0">
          The overview below shows the factsheets that your account has access to. 
          </p>
          <p v-else>
          It seems like your account does not have any factsheets associated with it yet. 
          </p>
          </div>
        </div>
        <div class="row" style="margin:0px -5px;">
            <Item v-for="item in factsheetsBasic" :item="item" :key="item.identifier"></Item>
        </div>
    </template>
    -->

      <div style="color: #888; font-size: 0.8em; padding-bottom: 10px">
        Background maps for reports shown are copyight OpenStreetMap
        contributors.
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import FactsheetCollection from "@/components/home/FactsheetCollection.vue";
import Item from "@/components/home/user/Item.vue";
import SubHeader from "@/components/factsheet/SubHeader.vue";

export default {
  data() {
    return {
      f_type: "ldr",
      loaded: false,
    };
  },
  created() {
    /* Load the main factsheet information via the factsheet API */
    this.loadFactsheetList();
  },
  components: {
    FactsheetCollection,
    Item,
    SubHeader,
  },
  mounted() {},
  computed: {
    profile() {
      return this.getProfile();
    },
    factsheets: function () {
      return this.$store.state.factsheets;
      if (this.$store.state.factsheets) {
        return this.$store.state.factsheets.filter(
          (item) => !item.factsheettype__name.indexOf(this.f_type)
        );
      } else {
        return [];
      }
    },
    projects: function () {
      if (this.$store.state.projects) {
        return this.$store.state.projects;
      } else {
        return [];
      }
    },
    countBasic: function () {
      return this.$store.state.factsheets.filter(
        (item) => item.factsheettype__name != "ldr"
      ).length;
    },
    countLDR: function () {
      return this.$store.state.factsheets.filter(
        (item) => item.factsheettype__name == "ldr"
      ).length;
    },
    factsheetsBasic: function () {
      return this.$store.state.factsheets.filter(
        (item) => item.factsheettype__name != "ldr"
      );
    },
    factsheetsLdr: function () {
      return this.$store.state.factsheets.filter(
        (item) => item.factsheettype__name == "ldr"
      );
    },
  },
  watch: {
    loaded: function () {},
  },
  methods: {
    loadFactsheetList() {
      const headers = {
        Authorization: "Token " + this.apitoken(),
      };
      this.$axios
        .all([
          this.$axios.get(process.env.VUE_APP_API + "/api/factsheet/", {
            headers: headers,
            validateStatus: () => true,
          }),
          this.$axios.get(process.env.VUE_APP_API + "/api/project/", {
            headers: headers,
            validateStatus: () => true,
          }),
        ])
        .then(
          this.$axios.spread((r1, r2) => {
            this.$store.commit("factsheets", r1.data);
            this.$store.commit("projects", r2.data);
            this.loaded = true;
          })
        )
        .catch((error) => console.log(error));
    },
    factsheetTypeCount(factsheettype) {
      return this.$store.state.factsheets.filter(
        (item) => item.factsheettype__name == factsheettype
      ).length;
    },
  },
  name: "Overview",
};
</script>

<style></style>

<style scoped>
h2 {
  font-size: 1.5em;
  font-weight: 600;
  color: #666;
}
ul.items {
  border: 0;
  margin: 0;
  padding: 0;
}
p {
  color: #666;
  font-size: 1.2em;
}

h4 {
  padding-left: 5px;
}
a.item-project {
  font-size: 1.35em;
  padding: 7px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  display: block;
  width: 100%;
  height: 125px;
  margin-bottom: 15px;
}
a.item-project:hover {
  border-color: #ccc;
  background-color: #fff;
}
a.item-project p {
  margin: 5px 0px;
  font-size: 0.8em;
  display: -webkit-box;
  max-width: 400px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-group-item {
  border-radius: 0px;
  padding: 9px;
}
.list-group-item.active {
  background-color: #cce5ff;
}
.list-group-item h5 {
  color: #007bff;
}
a.list-group-item:hover h5 {
  color: #0056b3;
}
.selected {
  background-color: #f5f5f5;
}
.selected h5 {
  font-weight: bold;
}
</style>
